import React from "react";
import {negativeColour, positiveColour} from "../../style/styleConsts";
import styled from "styled-components";

export const PositiveValue = styled.span`
     color: ${positiveColour};
`;

export const NegativeValue = styled.span`
     color: ${negativeColour};
`;

export default ({value, children}) => {
    return value > 0
            ? <PositiveValue>{children}</PositiveValue>
            : <NegativeValue>{children}</NegativeValue>;
};